import axios from "axios";

import myConfig from "../configs/config";

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("client-token")}`,
  };
}

export async function fetchWeatherReference(farmId) {
  const response = await axios.get(
    `${myConfig.API_URL}/farm/${farmId}/weather-reference/`,
    { headers: authHeaders() }
  );
  return response.data || null;
}

export async function saveWeatherReference(farmId, { lat, lng }) {
  const response = await axios.put(
    `${myConfig.API_URL}/farm/${farmId}/weather-reference/`,
    { lat, lng },
    { headers: authHeaders() }
  );
  return response.data;
}

export async function fetchFarmMapContext(farmId) {
  const response = await axios.get(`${myConfig.API_URL}/farm/${farmId}/`, {
    headers: authHeaders(),
  });
  return response.data || null;
}
